import { render, staticRenderFns } from "./userPopover.vue?vue&type=template&id=32f22cfc&scoped=true&"
import script from "./userPopover.vue?vue&type=script&lang=js&"
export * from "./userPopover.vue?vue&type=script&lang=js&"
import style0 from "./userPopover.vue?vue&type=style&index=0&id=32f22cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f22cfc",
  null
  
)

export default component.exports